import React from 'react';

import './style.css';

export const MenuSeparator: React.FC = () => (
  <li className="menu__separator">
    <hr />
  </li>
);
